import { memo, useMemo } from 'react';
import { LoadingSkeleton } from '../../../../common/components';
import { GERENCIALES_DEBT_STATUS_VIEW_CHART } from '../../constants/gerencialesConstants';
import DebtStatusTable from './DebtStatusTable';
import DebtStatusCharts from './DebtStatusCharts';

/**
 * Renderiza el informe de mora por estado.
 * @param {Object} props - Props del componente.
 * @param {boolean} props.loading - Estado de carga.
 * @param {Object|null} props.results - Resultados del reporte.
 * @param {Object|null} props.header - Header con metadata.
 * @param {string} props.reportView - Vista seleccionada (tabla/grafico).
 * @param {Function} props.onReload - Handler de recarga.
 * @param {Object} props.pagination - Datos de paginación.
 * @param {Function} props.onPageChange - Handler de página.
 * @param {Function} props.onRowsPerPageChange - Handler de items por página.
 * @returns {JSX.Element|null} Informe de mora.
 */
const DebtStatusReport = ({
  loading,
  results,
  header,
  reportView,
  onReload,
  pagination,
  onPageChange,
  onRowsPerPageChange,
}) => {
  const safeResults = useMemo(
    () => results || { table: [], charts: {} },
    [results]
  );
  const tableRows = useMemo(
    () => (Array.isArray(safeResults.table) ? safeResults.table : []),
    [safeResults]
  );
  const chartData = useMemo(() => safeResults.charts || {}, [safeResults]);

  if (loading && !results) {
    return <LoadingSkeleton />;
  }

  if (!results) {
    return null;
  }

  if (reportView === GERENCIALES_DEBT_STATUS_VIEW_CHART) {
    return <DebtStatusCharts header={header} chartData={chartData} />;
  }

  return (
    <DebtStatusTable
      rows={tableRows}
      totalContracts={header?.total_contracts ?? tableRows.length}
      onReload={onReload}
      pagination={pagination}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
    />
  );
};

export default memo(DebtStatusReport);
